import axios from '@/utils/request'
import env from '@/configs/env'


// export defult
const getQiniuToken = () => axios({
  url: env.qnTokenDomain
})

export default getQiniuToken
